<div class="login-wrapper template-animation">
  <!-- Left Side: Hero Section -->
  <div class="login-hero d-none d-lg-flex">
    <div class="hero-bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="glass-overlay"></div>
    </div>

    <div class="hero-content transformX-L-50 transition-delay-3">
      <img src="https://cdn.estore5s.com/asset/estore-logo-transparent.png" class="hero-logo" alt="logo">
      <h1 class="hero-title">{{ "Sign In to Your e - Commerce Hub" | translate }}</h1>
      <p class="hero-description">
        {{ "Southeast Asia's e-Commerce grew by almost 600%, attracting over 70 million annual online shoppers. Starting
        your eStore is a wise decision!" | translate}}
      </p>

      <div class="hero-stats transformX-L-50 transition-delay-5 mt-5">
        <div class="stat-item">
          <h3>600%</h3>
          <p>{{ "Growth" | translate }}</p>
        </div>
        <div class="stat-item">
          <h3>70M+</h3>
          <p>{{ "Shoppers" | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Side: Form Section -->
  <div class="login-form-section">
    <div class="form-container transformX-L-50 transition-delay-5">
      <!-- Mobile Logo -->
      <div class="mobile-logo-wrap d-block d-lg-none mb-4 text-center">
        <img src="https://cdn.estore5s.com/asset/estore-logo-transparent.png" class="mobile-logo" alt="Logo">
      </div>

      <div class="form-header mb-5">
        <h2 class="form-title">{{ "Welcome Back" | translate }}</h2>
        <p class="form-subtitle">{{ "Please enter your details to sign in." | translate }}</p>
      </div>

      <form method="POST" (submit)="$event.preventDefault()">
        <div class="input-group-custom mb-4">
          <label for="username">{{ "Username" | translate }}</label>
          <div class="input-wrapper">
            <i class="fa fa-user input-icon"></i>
            <input type="text" id="username" class="form-control-custom" name="username" [(ngModel)]="username"
              placeholder="{{ 'Enter FIV5s Username' | translate }}" required="required">
          </div>
        </div>

        <div class="input-group-custom mb-4">
          <label for="password">{{ "Password" | translate }}</label>
          <div class="input-wrapper">
            <i class="fa fa-lock input-icon"></i>
            <input id="password" [type]="showText ? 'text' : 'password'" class="form-control-custom" name="password"
              [(ngModel)]="password" placeholder="••••••••" required="required">
            <i (click)="showPassword()" [class]="showEye ? 'fa fa-eye text-primary' : 'fa fa-eye-slash text-muted'"
              class="toggle-password"></i>
          </div>
        </div>

        <div *ngIf="invalidCredentials" class="alert alert-danger error-message fade-in d-flex align-items-center mb-4">
          <i class="fa fa-exclamation-triangle" style="margin-right: 8px;"></i> {{ "Invalid Username / Password" |
          translate}}
        </div>

        <button (click)="validateAccount()" [disabled]="checkEmpty()" class="btn-login w-100 mt-2">
          <span *ngIf="!isLoading">{{ "Sign In" | translate}}</span>
          <span *ngIf="isLoading" class="spinner"><i class="fa fa-circle-o-notch fa-spin"
              style="margin-right: 8px;"></i>{{ "Signing In..." | translate }}</span>
        </button>
      </form>
    </div>
  </div>
</div>